import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DataBagService } from '../../common/data-bag.service';
import { FooterItem, FooterSection, FormControlObject } from './footer.model';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FooterService } from './footer.service';

@Component({
	selector: 'app-www-footer',
	templateUrl: './www-footer.component.html',
	styleUrls: ['./www-footer.component.scss'],
})
export class WwwFooterComponent implements OnInit {
	constructor(
		private readonly bag: DataBagService,
		public service: FooterService,
	) {}

	footerSections: FooterSection[] = [];
	displayedColumns: string[] = ['name', 'link', 'isActive'];
	inputControlsArrays: FormControlObject[][] = [];
	ngOnInit() {
		this.bag.get('/www/footer_section/', (result, error) => {
			if (result) {
				this.footerSections = result.results;
				this.footerSections.forEach((item) => {
					item.footerItem.sort((a, b) => {
						return a.order - b.order;
					});
				});
				this.initializeFormControls();
			} else throw new Error(JSON.stringify(error.error));
		});
	}

	protected addItem(i: number) {
		const section = this.footerSections[i];
		const item: FooterItem = {
			footerSection: section.id,
			id: 0,
			isActive: false,
			link: '',
			name: '',
			order: section.footerItem.length,
			isNew: true,
		};
		this.inputControlsArrays[i].push(this.createFormControlObject({ name: '', link: '' }));
		section.footerItem.push(item);
	}

	private createFormControlObject(value: { name: string; link: string }): FormControlObject {
		return {
			name: new FormControl(value.name, [Validators.required]),
			link: new FormControl(value.link, [
				Validators.required,
				Validators.pattern(
					'^(https?:\\/\\/.)[-a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)$',
				),
			]),
		};
	}

	protected changeEditState(i: number) {
		this.footerSections[i].editable = !this.footerSections[i].editable;
	}

	async submit(i: number) {
		this.markAllControlsAsTouched(i);
		if (this.checkFormControlsValidity(i)) {
			const section = this.footerSections[i];
			section.footerItem.forEach((value, index) => {
				value.name = this.inputControlsArrays[i][index].name.value;
				value.link = this.inputControlsArrays[i][index].link.value;
			});
			this.service.createFooterItems(section.footerItem.filter((v) => v.isNew));
			this.service.updateFooterItems(section.footerItem.filter((v) => !v.isNew));
			await this.changeEditState(i);
		}
	}

	private initializeFormControls() {
		for (const tableData of this.footerSections) {
			const inputControls: { name: FormControl; link: FormControl }[] = [];
			for (const row of tableData.footerItem) {
				const formControls = this.createFormControlObject({
					name: row.name,
					link: row.link,
				});
				inputControls.push(formControls);
			}
			this.inputControlsArrays.push(inputControls);
		}
	}

	private markAllControlsAsTouched(i: number) {
		for (const control of this.inputControlsArrays[i]) {
			control.name.markAsTouched();
			control.link.markAsTouched();
		}
	}

	private checkFormControlsValidity(i: number) {
		return !this.inputControlsArrays[i].some((v) => v.name.status === 'INVALID' || v.link.status === 'INVALID');
	}

	drop(event: CdkDragDrop<string[]>, i: number) {
		moveItemInArray(this.footerSections[i].footerItem, event.previousIndex, event.currentIndex);
		moveItemInArray(this.inputControlsArrays[i], event.previousIndex, event.currentIndex);
		this.footerSections[i].footerItem.forEach((value, index) => {
			value.order = index;
		});
	}
}
